"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckbox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CheckboxMixin = require("../../mixins/components/CheckboxMixin");
var _FormControl = require("../FormControl/FormControl");
var StyledCheckbox = /*#__PURE__*/(0, _styledComponents.default)(_FormControl.FormControl).withConfig({
  displayName: "StyledCheckbox",
  componentId: "c11n-8-107-0__sc-13jdanj-0"
})(["", ""], _CheckboxMixin.CheckboxMixin);
exports.StyledCheckbox = StyledCheckbox;